import { VendorName } from "./VendorName";
import { ContentEntryPublishRenderDescriptor } from "../ContentEntryPublishRenderDescriptor";

export class ContentEntryPublishRenderData{
    public ContentEntryDescriptor: ContentEntryPublishRenderDescriptor ;
    public DigitalBadgeID: string ;
    public TopicID: string ;
    public HasQuiz: boolean ;
    public SocialMediaShareImageBinaryAssetId: string ;
    public PremiumFeatureQuizVisibleToUser: boolean ;
    public VideoVendor: VendorName ;
    public VendorVideoID: string ;
    public Html: string ;
    public ExternalCitationLink: string ;
    public HidePopup: boolean ;
}